import React from 'react';
import Button from '../components/Button';
import styles from './Test.css';
import className from 'classnames/bind';
const cx = className.bind(styles);


const Test = (props) => {
  return (
    <div>
      <div className={styles.container}>
        <div className={cx('testText')}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas non nunc sagittis lorem tempor faucibus id eget magna. Nunc elementum, velit non dignissim auctor, sem nibh pharetra magna, in consequat ex metus vitae elit. Cras pellentesque erat sit amet nibh ultrices pretium. Phasellus nibh dolor, feugiat ac ex ac, finibus fermentum velit. Ut molestie mi urna, eleifend varius lorem fermentum a. Suspendisse dapibus, libero non mattis malesuada, est ante ullamcorper felis, id mattis justo sem sit amet ex. Suspendisse varius auctor augue non convallis. Phasellus a pharetra justo, ac auctor velit. Mauris tincidunt sem in luctus suscipit. Mauris rhoncus est libero, sit amet viverra libero dapibus sed. Suspendisse ullamcorper purus sed lectus ornare congue. In luctus diam sit amet risus sollicitudin pharetra.
        </div>
        <div className={styles.buttons}>
          <Button onClick={()=>{props.history.push('test2')}} >
          Test2
          </Button>
          <Button onClick={()=>{props.history.push('test')}} >
          Test1
          </Button>
        </div>
      </div>
      <div className={styles.container}>
      <div className={cx('testText')}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas non nunc sagittis lorem tempor faucibus id eget magna. Nunc elementum, velit non dignissim auctor, sem nibh pharetra magna, in consequat ex metus vitae elit. Cras pellentesque erat sit amet nibh ultrices pretium. Phasellus nibh dolor, feugiat ac ex ac, finibus fermentum velit. Ut molestie mi urna, eleifend varius lorem fermentum a. Suspendisse dapibus, libero non mattis malesuada, est ante ullamcorper felis, id mattis justo sem sit amet ex. Suspendisse varius auctor augue non convallis. Phasellus a pharetra justo, ac auctor velit. Mauris tincidunt sem in luctus suscipit. Mauris rhoncus est libero, sit amet viverra libero dapibus sed. Suspendisse ullamcorper purus sed lectus ornare congue. In luctus diam sit amet risus sollicitudin pharetra.
      </div>
      <div className={styles.buttons}>
        <Button onClick={()=>{props.history.push('test2')}} >
        Test2
        </Button>
        <Button onClick={()=>{props.history.push('test')}} >
        Test1
        </Button>
      </div>
    </div>
    </div>
  );
};

export default Test;


// WEBPACK FOOTER //
// ./src/routes/Test.js